// Dormant until an owned editor explicitly registers a verified checkpoint.
// This registry never reads storage, restores history or enables persistent Undo.
const uuid = value => typeof value === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(value);
export function validHistoryImageContext(value) {
  return !!value && typeof value.account === 'string' && /^[\x21-\x7e]{1,200}$/.test(value.account) && !value.account.includes('/') &&
    typeof value.projectID === 'string' && /^[a-zA-Z0-9_-]{1,80}$/.test(value.projectID) &&
    ['incarnation', 'epoch', 'token', 'contextToken'].every(key => uuid(value[key]));
}
export function createHistoryImageContextRegistry({ account, pathname, randomUUID = () => crypto.randomUUID(), changed = () => {} }) {
  let current = null;
  const notify = () => { try { changed(); } catch {} };
  const read = () => {
    if (!current) return null;
    try {
      if (account() !== current.value.account || pathname() !== '/p/' + current.value.projectID) return null;
      const result = current.assertCurrent();
      if (result === false || result?.then) return null;
      return { ...current.value };
    } catch { return null; }
  };
  return {
    register(identity, assertCurrent) {
      const value = { ...Object.fromEntries(['account','projectID','incarnation','epoch','token'].map(key => [key, identity?.[key]])), contextToken: randomUUID() };
      if (!validHistoryImageContext(value) || typeof assertCurrent !== 'function') throw new Error('A verified owned history context is required.');
      const next = { value: Object.freeze(value), assertCurrent };
      current = next;
      if (!read()) { current = null; notify(); throw new Error('The owning editor is no longer current.'); }
      notify();
      return () => { if (current === next) { current = null; notify(); } };
    },
    read,
    invalidate() { current = null; notify(); },
  };
}
